export default "__VITE_ASSET__BkZx1U4s__"